const config = {
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
  // like '/berry-material-react/react/default'
  basename: '/',
  defaultPath: '/panel/guide',
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif`,
  borderRadius: 12,
  siteInfo: {
    chat_link: '',
    display_in_currency: true,
    email_verification: false,
    footer_html: '',
    github_client_id: '',
    github_oauth: false,
    logo: '',
    quota_per_unit: 500000,
    server_address: '',
    start_time: 0,
    system_name: '涡拓 AI 网关', // 品牌名占位，见 docs/品牌资料.md
    top_up_link: '',
    turnstile_check: false,
    turnstile_site_key: '',
    version: '',
    wechat_login: false,
    wechat_qrcode: '',
    oidc: false,
    oidc_client_id: '',
    oidc_authorization_endpoint: '',
    oidc_token_endpoint: '',
    oidc_userinfo_endpoint: '',
    // 运营内容模块（本项目自有）：均为 JSON 数组字符串
    announcements: '',
    faq: '',
    api_info: '',
    client_launch_links: '',
    // 已启用的在线支付渠道名列表（后端 payment.Registered()）
    payment_methods: [],
    // 合规内容（商业化对外必需）：备案号挂页脚，协议页供支付宝签约审核访问
    icp_record_number: '',
    user_agreement_enabled: false,
    privacy_policy_enabled: false,
    // 注册是否开放：公开页 CTA 据此在「免费注册 / 登录」间切换（关注册时不引到死路）
    register_enabled: false,
  }
};

export default config;
